import { useEffect } from "react";
import { AlertCircle } from "lucide-react";

export function ErrorPage() {
  useEffect(() => {
    const isInIframe = window.self !== window.top;
    
    if (isInIframe) {
      // Send error message to parent window
      try {
        window.parent.postMessage({
          type: 'APPLICATION_ERROR',
          message: 'An error occurred while processing your application'
        }, '*'); // In production, specify exact origin: '<YOUR_WORDPRESS_DOMAIN>'
      } catch (e) {
        console.error('Error sending message to parent:', e);
      }
    }
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-red-50 to-orange-100 flex items-center justify-center p-4">
      <div className="max-w-2xl w-full bg-white rounded-2xl shadow-xl p-8 md:p-12 text-center">
        <div className="flex justify-center mb-6">
          <div className="bg-red-100 rounded-full p-4">
            <AlertCircle className="w-16 h-16 text-red-600" />
          </div>
        </div>
        
        <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
          Something Went Wrong
        </h1>
        
        <p className="text-xl md:text-2xl text-gray-700 mb-6">
          We're already fixing it, but we need your help
        </p>
        
        <div className="bg-blue-50 border-l-4 border-blue-500 p-6 rounded-r-lg mb-8">
          <p className="text-lg text-gray-800 mb-4 font-medium">
            Please call us directly:
          </p>
          <p className="text-2xl md:text-3xl font-bold text-blue-600">
            <a href="tel:866-874-0584" className="hover:text-blue-800 underline">
              866-874-0584
            </a>
          </p>
          <p className="text-gray-600 mt-4">
            Our team is standing by to help you complete your financing application.
          </p>
        </div>
        
        <div className="text-sm text-gray-500">
          <p>We apologize for the inconvenience.</p>
        </div>
      </div>
    </div>
  );
}

